<template>
    <div class="table-container">
        <div class="actions-tab in-tab">
            <b-dropdown variant="link" left toggle-class="text-decoration-none" no-caret>
                <template #button-content>
                    <div class="btn-download">
                        <div>
                  <span class="left">
                      <i class="icon icon-download"></i> {{ setText('download') }}
                  </span>
                            <i class="icon icon-keyboard"></i>
                        </div>
                    </div>
                </template>
                <b-dropdown-item class="text-left" @click="downloadFile('UTOCH_P')">{{setText('refined_plan')}}(UTOCH_P)</b-dropdown-item>
            </b-dropdown>
            <b-dropdown variant="link" class="info" right toggle-class="text-decoration-none" no-caret>
                <template #button-content>
                    <div class="btn-download">
                        <div>
                            <span class="left">
                                <i class="icon icon-info"></i>
                            </span>
                            <i class="icon icon-keyboard"></i>
                        </div>
                    </div>
                </template>
                <b-dropdown-text>
                    <div class="info-button">
                        <a href="https://youtu.be/6OR4ztOq9mU" target="_blank"><span>{{setText('video_instructions.utochPlan')}} <i
                            class="icon icon-video"></i></span></a>
                    </div>
                </b-dropdown-text>
            </b-dropdown>
        </div>
        <table class="table b-table table-bordered b-table-no-border-collapse">
            <thead>
            <tr>
                <th>№</th>
                <th>{{setText('name')}}</th>
                <th>{{setText('date')}}</th>
                <th>{{setText('status')}}</th>
                <th>{{setText('base')}}</th>
                <th>{{setText('comment')}}</th>
                <th>{{setText('user')}}</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            <template v-for="row of requestsBase">
                <tr :key="row.id" @click="downloadApp(row)" :class="{ 'selected_row': row.selected }" style="cursor: pointer;">
                    <td>{{ row.number }}</td>
                    <td :id="'app-name-' + row.id"
                        @contextmenu.prevent="showContextMenu($event, row.id)"
                        @mouseleave="hidePopoverDelayed"
                        @mouseenter="cancelHidePopover(row.id)">
                        <a href="#" @click="rowOpen(row)">
                            {{setText('revised_budget')}} №{{ row.number}}
                        </a>
                        <b-popover v-if="showId" :target="'app-name-' + row.id" :show="activePopoverId === row.id" triggers="manual" placement="top" :delay="{ show: 150, hide: 400 }">
                            <div style="display: flex; align-items: center;" @mouseenter="cancelHidePopover(row.id)" @mouseleave="hidePopoverDelayed">
                                <span style="margin-right: 8px;">ID: {{ row.id }}</span>
                                <b-button size="sm" variant="outline-primary" style="padding: 2px 5px; font-size: 12px;" @click.stop.prevent="copyId(row.id); activePopoverId = null">
                                    {{setText('copy')}}
                                </b-button>
                            </div>
                        </b-popover>
                    </td>
                    <td>{{ row.date|formatDate }}</td>
                    <td v-if="('status' in row && row.status !== null)" style="text-align: center;">{{ getLocalStatus(row) }}
                        <span class="doc-icon" v-if="row.parent !== null">
                            <img
                                onerror="this.style.display = 'none'"
                                :src="''"
                                alt="icon"
                                style="width: 20px; height: 20px"
                            />
                        </span>
                    </td>
                    <td v-else></td>
                    <td>{{ row.description }}</td>
                    <td v-if="row.status">{{ row.status.comment }}</td>
                    <td v-else></td>
                    <td>{{ row.userName }}</td>
                    <td>
                        <b-dropdown v-if="hasEditAccess(row) || hasDeleteAccess(row)" dropleft class="more-dropdown">
                            <template v-slot:button-content>
                                <i class="icon icon-more"></i>
                            </template>
                            <template>
                                <b-dropdown-item-btn v-if="hasEditAccess(row)" @click="() => {onChange(row);}">
                                    <i class="icon icon-pencil-edit"></i>{{setText('edit')}}
                                </b-dropdown-item-btn>
                                <b-dropdown-item-btn v-if="hasDeleteAccess(row)" @click="() => {onDelete(row);}"
                                ><i class="icon icon-close" style="color: red;"></i>
                                    <span  style="color: red;"> {{setText('delete')}}</span>
                                </b-dropdown-item-btn>
                                <b-dropdown-item-btn @click="openHistory(row)">{{setText('history')}}</b-dropdown-item-btn>
                            </template>
                        </b-dropdown>
                        <b-dropdown v-else dropleft class="more-dropdown">
                            <template v-slot:button-content>
                                <i class="icon icon-more"></i>
                            </template>
                            <template>
                                <b-dropdown-item-btn @click="openHistory(row)">{{setText('history')}}</b-dropdown-item-btn>
                            </template>
                        </b-dropdown>
                    </td>
                </tr>
            </template>
            </tbody>
        </table>
        <b-exec-agr-hist-modal ref="refHistModal" :status-types="statusType" :with-time="true"/>
    </div>
</template>

<script>
import axios from "axios";
import BExecAgrHistModal from "@/modules/budget/execution/form/tabs/components/BExecAgrHistModal";
import AlterationI18nMixin from "@/modules/budget/alteration/mixins/alteration-i18n-mixin";
import moment from 'moment'

export default {
    name: "UtochRequestTable",
    components: { 'b-exec-agr-hist-modal': BExecAgrHistModal },
    mixins: [ AlterationI18nMixin ],
    props: {
        requestsBase: {},
        accessLevels: {},
        statusType: {},
        isLoadToJournalEnabled: {},
        showId: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            activePopoverId: null,
            hidePopoverTimer: null,
            levelsCheck: true,
            selectedAlteration: null
        }
    },
    mounted() {
        document.addEventListener('click', this.hidePopover);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.hidePopover);
        if (this.hidePopoverTimer) {
            clearTimeout(this.hidePopoverTimer);
        }
    },
    methods: {
        hidePopover(e) {
            if (this.activePopoverId) {
                // Игнорируем клик внутри самого popover
                if (e && e.target && typeof e.target.closest === 'function' && e.target.closest('.popover')) return;
                this.activePopoverId = null;
            }
        },
        showContextMenu(e, id) {
            if (!this.showId) return;
            if (this.hidePopoverTimer) {
                clearTimeout(this.hidePopoverTimer);
            }
            this.activePopoverId = id;
        },
        hidePopoverDelayed() {
            this.hidePopoverTimer = setTimeout(() => {
                this.activePopoverId = null;
            }, 1500);
        },
        cancelHidePopover(id) {
            if (this.activePopoverId === id && this.hidePopoverTimer) {
                clearTimeout(this.hidePopoverTimer);
            }
        },
        haveEditAccess(row) {
            return 'status' in row && row.status !== null && this.editAccessStatusList.includes(row.status.status) && this.incTab
                && (this.roleIncludes('gu_edit')|| this.roleIncludes('uf_edit')|| this.roleIncludes('abp_agree'))
                && !([2, 3].includes(this.tabIndex) && this.roleIncludes('abp_educ'))
        },
        hasEditAccess(row) {
            return this.accessLevels.editAccess && this.accessLevels.position === 'uf' && (row.status && ([1, 27, 69].includes(row.status.status)))
        },
        hasDeleteAccess(row) {
            return this.accessLevels.editAccess && this.accessLevels.position === 'uf' && (row.status && ([1, 27, 69].includes(row.status.status)))
        },
        onOpen(item){
            this.$emit('onOpen', item);
        },
        rowOpen(row) {
            this.onOpen(row);
        },
        onChange(item) {
            this.$emit('onChange', item)
        },
        onDelete(item) {
            this.$emit('onDelete', item)
        },
        getLocalStatus(value) {
            const status = value.status.status;
            if (!this.statusType || !this.statusType.length) return status;
            const curStatus = this.statusType.filter((item) => item.code === status);
            if (!curStatus || !curStatus.length) return status;
            const localName = curStatus[0]["name_" + this.$i18n.locale];
            return localName;
        },
        downloadApp(item) {
            for (const r of this.requestsBase) {
                r.selected = false;
            }
            this.selectedAlteration = item;
            item.selected = !item.selected;
            item.id += 1;
            item.id -= 1;
        },
        async downloadFile(app) {
            try {
                if (this.isLoadToJournalEnabled) {
                    // Выгрузка в журнал
                    const item = this.requestsBase.find(x => x.selected);
                    const params = {
                        'type': 'PAYMENT',
                        'requestId': item.id,
                        'level': 'UF',
                        'dataLevel': 'PRG',
                        'addIpf': false,
                        'addSpp': false,
                        'addAllAgreed': false,
                        'showDistributedPrg': false,
                        'code': app,
                    }

                    const strDate = new Date(this.selectedAlteration.date).toLocaleDateString();
                    const filename = `Уточненный план_${this.selectedAlteration.region}_${this.selectedAlteration.number}_${strDate}.xls`

                    const journalParams = {
                        sourceTab: 'refined_plan',
                        region: item.region,
                        abp: item.abp,
                        gu: item.gu,
                        number: item.number,
                        requestType: item.requestType,
                        date: moment(item.date).format('YYYY-MM-DD'),
                        agreementStatus: item.status.status,
                        name: 'Уточненный план',
                        parameters: params,
                        reportKey: 'BASE',
                        filename: filename,
                    }

                    const initilizeResponse = await fetch('/api/alteration/journal', {
                        method: 'POST',
                        body: JSON.stringify(journalParams),
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    if (!initilizeResponse.ok) {
                        this.makeToast('danger', 'Ошибка', 'Ошибка инициализации в журнал')
                        return
                    }
                    const entryId = await initilizeResponse.text()
                    this.makeToast('success', 'Внимание!', 'Началась выгрузка. Для скачивания отчета перейдите во вкладку "Журнал"')
                    fetch(`/api/alteration/journal/${entryId}`, {
                        method: 'POST',
                    })

                    this.$emit('reload-journal')
                    return
                } else {
                    // Прямая выгрузка
                    const item = this.requestsBase.find(x => x.selected);
                    const response = await axios.get(`api/budget-execution-base/xls?type=PAYMENT&requestId=${item.id}&level=UF&dataLevel=PRG&addIpf=false&addSpp=false&addAllAgreed=false&showDistributedPrg=false&code=${app}`, {responseType: 'blob'})

                    const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/xls'}));
                    const link = document.createElement('a');
                    link.href = url;
                    link.target = '_blank';
                    const date = new Date(this.selectedAlteration.date).toLocaleDateString();
                    link.setAttribute('download', `Уточненный план_${this.selectedAlteration.region}_${this.selectedAlteration.number}_${date}`+ '.xls');
                    document.body.appendChild(link);
                    link.click();
                }
            } catch (error) {
                console.error(this.setText('errors.file'), error.toString());
                this.toast('danger', this.i18n.translate('error.cannot_load_files'), this.setText('refined_plan_nf'))
            }
        },
        async openHistory(agrObj) {
            if (agrObj !== null) {
                await this.$refs.refHistModal.showEvent(agrObj);
            }
        },
        copyId(id) {
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(id).then(() => {
                    this.makeToast('success', this.setText('success'), this.setText('id_copied') + id);
                });
            } else {
                const textArea = document.createElement("textarea");
                textArea.value = id;
                textArea.style.position = "fixed";
                textArea.style.left = "-999999px";
                textArea.style.top = "-999999px";
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                try {
                    document.execCommand('copy');
                    this.makeToast('success', this.setText('success'), this.setText('id_copied') + id);
                } catch (error) {
                    console.error(this.setText('copy_error'), error);
                    this.makeToast('danger', this.setText('errors.err'), this.setText('id_not_copied'));
                }
                textArea.remove();
            }
        },
    },
    filters: {
        formatDate: function (value) {
            if (value) {
                const date = new Date(value);
                return date.toLocaleDateString();
            }
            return null;
        }
    }
}
</script>

<style scoped>
.selected_row {
    background-color: #86cfda;
}
</style>